export default {
    choose: 'Pick a client',
    chooseText: 'Open a recent conversation or find a client with the search.',
    findAthlete: 'Find profile',
    back: 'Back',
    noMore: 'Start of the conversation',
    today: 'Today',
    yesterday: 'Yesterday',
    loadError: "Couldn't load the messages.",
    retry: 'Try again',
    typeHere: 'Write a message…',
    send: 'Send',
    unread: 'Unread',
    recent: 'Recent conversations',
    results: 'Results',
    searchPlaceholder: 'Search clients…',
    empty: {
        recent: {
            title: 'No conversations yet',
            subtitle: 'Find a client with the search and send them your first message.'
        },
        noMatch: {
            title: 'No clients found',
            subtitle: 'You can only chat with clients who are connected with you on the athlisis app.'
        },
        messages: {
            title: 'Start the conversation',
            subtitle: 'No messages yet. Write the first one in the box below.'
        }
    }
}
